export default __webpack_public_path__ + "static/media/9-Aubo.f4aa50a3.png";